import React, { useEffect, useState } from 'react';
import { useRestaurant } from '../../../contexts/restaurant.context';
import { getWorkHours } from '../../../components/common';

const MoreInfo = () => {
    const [today, setToday] = useState(null);

    const restaurant = useRestaurant();

    const isOpen24 = !!restaurant?.open_24hrs && !!restaurant?.open_24hrs?.length;
    const isOpen = isOpen24 || !!today;
    
    let todayDayName = restaurant?.todayName || ''; 
    if (todayDayName) {
        todayDayName = todayDayName.charAt(0).toUpperCase() + todayDayName.slice(1);
    }
    
    useEffect(() => {
        if (!restaurant) {
            return;
        }
        
        setToday(getWorkHours(restaurant));
    }, [restaurant]);
    
    return (
        <div className="d-flex flex-column" style={{ gap: '1.5rem' }}>
            <div className="card shadow">
                <div className="card-header pb-1">
                    <h5>Address</h5>
                </div>
                <div className="card-body pt-1">
                    {restaurant.address && (
                        <span className="d-block mb-2">{restaurant.address}</span>
                    )}
                    {restaurant.phone && (
                        <span className="d-block">{restaurant.phone}</span>
                    )}
                </div>
            </div>

            <div className="card shadow">
                <div className="card-header">

                    <div className="d-flex justify-content-between">
                        <h5>Today</h5>
                        <h5 className="text-danger">{isOpen ? 'Open Now' : 'Closed Now'}</h5>
                    </div>

                    {today && (
                        <div className="row">
                            <div className="col-3">
                                <h6>Hours</h6>
                            </div>
                            <div className="col-9 text-right">
                                {(+today.endHour - +today.beginHour) === 24 ? (
                                    <h6>24 hrs</h6>
                                ) : (
                                    <h6>{`${today.begin} - ${today.end}`}</h6>
                                )}
                            </div>
                        </div>
                    )}

                </div>
                <div className="card-body">
                    <h5>Full Schedule</h5>
                    <ul className="business-hours m-0 p-0 d-flex flex-column" style={{ gap: '1.5rem', }}>
                        {isOpen24 && (
                            <li className="d-flex justify-content-between">
                                <div>{todayDayName}</div>
                                <div className="text-right">24 hrs</div>
                            </li>
                        )}
                        {restaurant.business_hours.map(business_hour => (
                            <li className="d-flex justify-content-between">
                                <div>{business_hour.dayFull}</div>
                                {(+business_hour.endHour - +business_hour.beginHour) === 24 ? (
                                    <div className="text-right">24 hrs</div>
                                ) : (
                                    <div className="text-right">{`${business_hour.begin} - ${business_hour.end}`}</div>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MoreInfo;
